import React from 'react';
import { Tooltip } from 'antd';
import {
  AddressDduCell,
  DeskCell,
  FinishTypeCell,
  IndividualEndDateCell,
  IndividualStartDateCell,
  NumberDduCell,
  RelationCell,
  RoomNumberCell,
  RoomTypeCell,
  ServiceCell,
} from '../components/cells';
import SelectFilter from '../components/SelectFilter';
import RecordCell from '../components/RecordCell';
import { keysMap } from '../constants/columns';
import { searchParamKeys } from '../../../shared/configs/searchParams';
import ActionsCell from '../components/ActionsCell';
import PorchCell from '../components/PorchCell';
import { RetryIcon } from '../../../../../resource/icons';
import RepeatCell from '../components/RepeatCell';
import AcceptanceStatusCell from '../components/AcceptanceStatusCell';
import { Table } from '../../base/Table';
import StageCell from '../components/StageCell';
import StepCell from '../components/StepCell';
import DateFilter from '../components/DateFilter';

export const colRegistry = {
  [keysMap.room]: {
    key: keysMap.room,
    label: '№',
    width: '80px',
    Cell: RoomNumberCell,
    filter: (
      <Table.Filter
        name={searchParamKeys.roomsTableFlatNumber}
        placeholder="Поиск по номеру помещения"
        type="search"
      />
    ),
  },
  [keysMap.addressDdu]: {
    key: keysMap.addressDdu,
    label: (
      <Tooltip title="Номер помещения по ДДУ">
        <span>№ по ДДУ</span>
      </Tooltip>
    ),
    width: '108px',
    Cell: AddressDduCell,
    filter: (
      <Table.Filter
        name={searchParamKeys.roomsTableAddressDdu}
        placeholder="Поиск по номеру помещения по ДДУ"
        type="search"
      />
    ),
  },
  [keysMap.numberDdu]: {
    key: keysMap.numberDdu,
    label: (
      <Tooltip title="Договор долевого участия">
        <span>ДДУ</span>
      </Tooltip>
    ),
    width: '140px',
    Cell: NumberDduCell,
    filter: (
      <Table.Filter
        name={searchParamKeys.roomsTableNumberDdu}
        placeholder="Поиск по номеру ДДУ"
        type="search"
      />
    ),
  },
  [keysMap.relation]: {
    key: keysMap.relation,
    label: 'Связанность',
    width: '128px',
    Cell: RelationCell,
    filter: <SelectFilter name={searchParamKeys.roomsTableHasRelations} />,
  },
  [keysMap.type]: {
    key: keysMap.type,
    label: 'Тип',
    width: '140px',
    Cell: RoomTypeCell,
    filter: <SelectFilter name={searchParamKeys.roomsTableType} multiple />,
  },
  [keysMap.porch]: {
    key: keysMap.porch,
    label: 'Подъезд',
    width: '90px',
    Cell: PorchCell,
    filter: <SelectFilter name={searchParamKeys.roomsTablePorch} multiple />,
  },
  [keysMap.stage]: {
    key: keysMap.stage,
    label: 'Стадия',
    width: '140px',
    Cell: StageCell,
    filter: <SelectFilter name={searchParamKeys.roomsTableStage} multiple />,
  },
  [keysMap.step]: {
    key: keysMap.step,
    label: 'Этап',
    width: '140px',
    Cell: StepCell,
    filter: <SelectFilter name={searchParamKeys.roomsTableStep} multiple />,
  },
  [keysMap.status]: {
    key: keysMap.status,
    label: 'Статус',
    width: '140px',
    Cell: AcceptanceStatusCell,
    filter: <SelectFilter name={searchParamKeys.roomsTableStatus} multiple />,
  },
  [keysMap.service]: {
    key: keysMap.service,
    label: 'Услуга',
    width: '140px',
    Cell: ServiceCell,
    filter: <SelectFilter name={searchParamKeys.roomsTableService} multiple />,
  },
  [keysMap.desk]: {
    key: keysMap.desk,
    label: 'Стол',
    width: '100px',
    Cell: DeskCell,
    filter: <SelectFilter name={searchParamKeys.roomsTableDesk} multiple />,
  },
  [keysMap.individualStartDate]: {
    key: keysMap.individualStartDate,
    label: 'Дата начала',
    width: '100px',
    Cell: IndividualStartDateCell,
  },
  [keysMap.individualEndDate]: {
    key: keysMap.individualEndDate,
    label: 'Дата окончания',
    width: '100px',
    Cell: IndividualEndDateCell,
  },
  [keysMap.date]: {
    key: keysMap.date,
    label: 'Дата записи',
    width: '140px',
    Cell: RecordCell,
    filter: <DateFilter name={searchParamKeys.roomsTableRecordDate} />,
  },
  [keysMap.repeat]: {
    key: keysMap.repeat,
    label: (
      <Tooltip title="Повторные">
        <RetryIcon style={{ height: '16px' }} />
      </Tooltip>
    ),
    width: '50px',
    Cell: RepeatCell,
    filter: <SelectFilter name={searchParamKeys.roomsTableRepeat} />,
  },
  [keysMap.finishType]: {
    key: keysMap.finishType,
    label: 'Вид отделки',
    width: '140px',
    Cell: FinishTypeCell,
    filter: (
      <SelectFilter name={searchParamKeys.roomsTableFinishType} multiple />
    ),
  },
  [keysMap.actions]: {
    key: keysMap.actions,
    width: '56px',
    Cell: ActionsCell,
  },
};
